"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Select = _interopRequireDefault(require("../Select"));

var _Option = _interopRequireDefault(require("../Select/Option"));

var _Tabs = _interopRequireDefault(require("../Tabs"));

var _Tab = _interopRequireDefault(require("../Tabs/Tab"));

var _TabList = _interopRequireDefault(require("../Tabs/TabList"));

var _Pill = _interopRequireDefault(require("../Pill"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _breakpoints = _interopRequireDefault(require("../../constants/breakpoints"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding: ", ";\n\tborder-width: 0 1px 1px 1px;\n\tborder-color: ", ";\n\tborder-style: solid;\n\n\t@media screen and (min-width: ", ") {\n\t\tpadding: 0;\n\t\tborder: none;\n\t}\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin: 0 auto;\n\twidth: 90%;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding: 0 ", ";\n\tbackground-color: ", ";\n\t@media screen and (min-width: ", ") {\n\t\tdisplay: none;\n\t}\n\n\tselect {\n\t\twidth: 100% !important;\n\t}\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\t@media screen and (min-width: ", ") {\n\t\tli {\n\t\t\tpadding: 0.5rem 2rem;\n\t\t}\n\t}\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t@media screen and (min-width: ", ") {\n\t\tli {\n\t\t\tflex: 1 1 auto;\n\t\t\tjustify-content: center;\n\t\t}\n\t}\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: none;\n\t@media screen and (min-width: ", ") {\n\t\tdisplay: flex;\n\n\t\tli {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t}\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var BaseTabList = (0, _styledComponents.default)(_TabList.default)(_templateObject(), _breakpoints.default.tablet);
BaseTabList.displayName = 'BaseTabList';
var AutoWidthTabList = (0, _styledComponents.default)(BaseTabList)(_templateObject2(), _breakpoints.default.tablet);
AutoWidthTabList.displayName = 'AutoWidthTabList';
var StyledTabList = (0, _styledComponents.default)(BaseTabList)(_templateObject3(), _breakpoints.default.tablet);
StyledTabList.displayName = 'StyledTabList';

var MobileTabList = _styledComponents.default.div(_templateObject4(), _spacing.default.s3, _colors.default.primary, _breakpoints.default.tablet);

MobileTabList.displayName = 'MobileTabList';
var TabSelect = (0, _styledComponents.default)(_Select.default)(_templateObject5());
TabSelect.displayName = 'TabSelect';

var ContentWrappper = _styledComponents.default.div(_templateObject6(), _spacing.default.s2, _colors.default.greyLight, _breakpoints.default.tablet);

ContentWrappper.displayName = 'ContentWrappper';

var ResponsiveTabs = function ResponsiveTabs(_ref) {
  var tabsProp = _ref.tabs,
      defaultIndex = _ref.defaultIndex,
      children = _ref.children,
      autoTabWidth = _ref.autoTabWidth,
      rest = _objectWithoutPropertiesLoose(_ref, ["tabs", "defaultIndex", "children", "autoTabWidth"]);

  var _useState = (0, _react.useState)(defaultIndex || 0),
      index = _useState[0],
      setIndex = _useState[1];

  var onSelectChange = function onSelectChange(event, tabs) {
    var names = tabs.map(function (tab) {
      return tab.name;
    });
    var newIndex = names.indexOf(event.target.value);
    setIndex(newIndex);
  };

  var onSelect = function onSelect(newIndex) {
    setIndex(newIndex);
  };

  var tabs = tabsProp || _react.default.Children.map(children, function (child) {
    return child && child.props && child.props.name ? {
      name: child.props.name,
      counter: child.props.counter
    } : null;
  });

  var DesktopTabList = autoTabWidth ? AutoWidthTabList : StyledTabList;
  return _react.default.createElement(_Tabs.default, _extends({
    selectedIndex: index
  }, rest, {
    onSelect: onSelect
  }), _react.default.createElement(MobileTabList, null, _react.default.createElement(TabSelect, {
    name: "selectPanel",
    onChange: function onChange(event) {
      return onSelectChange(event, tabs);
    },
    value: tabs[index].name
  }, tabs.map(function (_ref2) {
    var name = _ref2.name,
        _ref2$counter = _ref2.counter,
        counter = _ref2$counter === void 0 ? null : _ref2$counter;
    return _react.default.createElement(_Option.default, {
      key: name,
      value: name
    }, "" + name + (counter !== null ? " (" + counter + ")" : ''));
  }))), _react.default.createElement(DesktopTabList, null, tabs.map(function (_ref3) {
    var name = _ref3.name,
        _ref3$counter = _ref3.counter,
        counter = _ref3$counter === void 0 ? null : _ref3$counter;
    return _react.default.createElement(_Tab.default, {
      key: name
    }, name, ' ', counter !== null ? _react.default.createElement(_Pill.default, null, counter) : null);
  })), _react.default.createElement(ContentWrappper, null, children));
};

ResponsiveTabs.propTypes = {
  tabs: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    name: _propTypes.string.isRequired,
    counter: _propTypes.number
  })),
  autoTabWidth: _propTypes.bool,
  defaultIndex: _propTypes.number,
  children: (0, _propTypes.oneOfType)([_propTypes.node, (0, _propTypes.arrayOf)(_propTypes.node)]).isRequired
};
ResponsiveTabs.defaultProps = {
  tabs: undefined,
  defaultIndex: 0,
  autoTabWidth: false
};
var _default = ResponsiveTabs;
exports.default = _default;